{
  "key": "foreshore-caravan-park",
  "title": "Foreshore caravan park",
  "suburb": "Coolamon Bay",
  "locationGroup": "parks",
  "grassType": "buffalo",
  "cellM": 0.5,
  "w": 80,
  "h": 52,
  "rows": [
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    "egggggggggggggggggbgggggggggggggggggbgggggggggggggggggbbgggggggbbbggggggbggggbbe",
    "egggggggggggggggogbgggggggggggggggggbgggggggogggggggggbgggggggobbbggggggbggggbbe",
    "eggggggoooooggggggbggggggoooooggggggbggggggoooooggggggbggggggggbbgggggggbggggbbe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbgppppppggggggggggbggggbbe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbgppppppggggggggggbggggbbe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbgppppppggggggggggbggggbbe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbgpoooopggggggggggbggggbbe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbgpoooopggggggggggbggggbbe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbgpoooopggggggggggbggggbbe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbgpoooopggggggggggbggggbbe",
    "egpoooopggggggggggbgpoooopggggggggggbgpoooopggggggggggbgpoooopggggggggggbgggggge",
    "egpooooppppppgggggbgpooooppppppgggggbgpooooppppppgggggbgpooooppppppgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbgggggge",
    "egpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbgggggge",
    "egpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbgggggge",
    "egpppppppppppgogggbgpppppppppppgogggbgpppppppppppgogggbgpppppppppppgogggbgggggge",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "pppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "egpppppppppppgogggbgpppppppppppgogggbgpppppppppppgogggbppppppppppppppppppppppppe",
    "egpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbppooooppppppooooppppppppe",
    "egpppppppooopgggggbgpppppppooopgggggbgpppppppooopgggggbppooooppppppooooppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbppppppppppppppppppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbppppppppppppppppppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbppppppppppppppppppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbppppppppppppppppppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbpppoooooooooooopppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbpppoooooooooooopppppppppe",
    "egpooooppooopgggggbgpooooppooopgggggbgpooooppooopgggggbpppoooooooooooopppppppppe",
    "egpooooppppppgggggbgpooooppppppgggggbgpooooppppppgggggbpppoooooooooooopppppppppe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbpppoooooooooooopppppppppe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbpppoooooooooooopppppppppe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbpppoooooooooooopppppppppe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbpppoooooooooooopppppppppe",
    "egpoooooooooggggggbgpoooooooooggggggbgpoooooooooggggggbpppoooooooooooopppppppppe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbpppoooooooooooopppppppppe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbpppoooooooooooopppppppppe",
    "egpppppoooooggggggbgpppppoooooggggggbgpppppoooooggggggbppppppppppppppppppppppppe",
    "egggggggggggggggggbgggggggggggggggggbgggggggggggggggggbppppppppppppppppppppppppe",
    "egggggggggggggggggbgggggggggggogggggbgggggggggggggggggbppppppppppppppppppppppppe",
    "egggggggggggggggggbgggggggggggggggggbgggggggggggggggggbppppppppppppppppppppppppe",
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
  ],
  "zones": [
  ],
  "rangeMm": [40,60],
  "startLengthMm": [70,110],
  "props": [
    {"id":"caravan-1","kind":"caravan","x":2.5,"y":6.75,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-1","kind":"car","x":5.25,"y":8.75,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-1","kind":"annexe","x":4.95,"y":3.5,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-1","kind":"power-pit","x":7,"y":11.25,"w":0.3,"h":0.3,"solid":true},
    {"id":"caravan-2","kind":"caravan","x":11.5,"y":6.75,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-2","kind":"car","x":14.25,"y":8.75,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-2","kind":"annexe","x":13.95,"y":3.5,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-2","kind":"power-pit","x":16,"y":11.25,"w":0.3,"h":0.3,"solid":true},
    {"id":"caravan-3","kind":"caravan","x":20.5,"y":6.75,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-3","kind":"car","x":23.25,"y":8.75,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-3","kind":"annexe","x":22.95,"y":3.5,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-3","kind":"power-pit","x":25,"y":11.25,"w":0.3,"h":0.3,"solid":true},
    {"id":"tap-1","kind":"tap","x":26.5,"y":11.25,"r":0.1,"solid":false},
    {"id":"caravan-4","kind":"caravan","x":29.5,"y":6.75,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-4","kind":"car","x":32.25,"y":8.75,"w":1.9,"h":4.4,"solid":true},
    {"id":"power-pit-4","kind":"power-pit","x":34,"y":11.25,"w":0.3,"h":0.3,"solid":true},
    {"id":"tap-2","kind":"tap","x":35.5,"y":11.25,"r":0.1,"solid":false},
    {"id":"caravan-5","kind":"caravan","x":2.5,"y":19.25,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-5","kind":"car","x":5.25,"y":17.25,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-4","kind":"annexe","x":4.95,"y":22,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-5","kind":"power-pit","x":7,"y":14.75,"w":0.3,"h":0.3,"solid":true},
    {"id":"tap-3","kind":"tap","x":8.5,"y":14.75,"r":0.1,"solid":false},
    {"id":"caravan-6","kind":"caravan","x":11.5,"y":19.25,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-6","kind":"car","x":14.25,"y":17.25,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-5","kind":"annexe","x":13.95,"y":22,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-6","kind":"power-pit","x":16,"y":14.75,"w":0.3,"h":0.3,"solid":true},
    {"id":"tap-4","kind":"tap","x":17.5,"y":14.75,"r":0.1,"solid":false},
    {"id":"caravan-7","kind":"caravan","x":20.5,"y":19.25,"w":2.4,"h":6.5,"solid":true},
    {"id":"car-7","kind":"car","x":23.25,"y":17.25,"w":1.9,"h":4.4,"solid":true},
    {"id":"annexe-6","kind":"annexe","x":22.95,"y":22,"w":2.5,"h":3.5,"solid":true},
    {"id":"power-pit-7","kind":"power-pit","x":25,"y":14.75,"w":0.3,"h":0.3,"solid":true},
    {"id":"tap-5","kind":"tap","x":26.5,"y":14.75,"r":0.1,"solid":false},
    {"id":"camp-kitchen-1","kind":"camp-kitchen","x":32,"y":20.75,"w":6,"h":5,"solid":true},
    {"id":"bench-1","kind":"bench","x":29.5,"y":15.5,"w":1.8,"h":0.6,"solid":true},
    {"id":"bench-2","kind":"bench","x":34.5,"y":15.5,"w":1.8,"h":0.6,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":8.25,"y":1.25,"r":0.4,"solid":true,"canopyR":3.2},
    {"id":"gum-tree-2","kind":"gum-tree","x":22.25,"y":1.25,"r":0.4,"solid":true,"canopyR":3.2},
    {"id":"gum-tree-3","kind":"gum-tree","x":15.25,"y":24.75,"r":0.4,"solid":true,"canopyR":3.2},
    {"id":"gum-tree-4","kind":"gum-tree","x":31.25,"y":1.25,"r":0.4,"solid":true,"canopyR":3.2}
  ],
  "spawn": {"x":1,"y":13,"heading":0},
  "utePark": {"x":1.5,"y":12.5,"heading":0},
  "weedFraction": 0.3,
  "leaves": {"count":[180,300]},
  "camera": {"fit":"follow","allowLandscape":true},
  "mutations": ["ibis","heavy-leaves","bin-night","magpie-season","hot-day","lost-ball","sprinkler"]
}
